import { emptyHighlighterApi as api } from './api';
export const addTagTypes = [
  'Boxes',
  'Chaining',
  'Clients',
  'FAKE_TAG_BECAUSE_THIS_ENDPOINT_SHOULD_NOT_INVALIDATE_ANYTHING',
  'FunnelSummary',
  'HighlighterAccounts',
  'NewHighlighterAccounts',
  'HighlighterAddresses',
  'HighlighterAnswers',
  'HighlighterBoxes',
  'HighlighterExperiences',
  'HighlighterGeneration',
  'HighlighterNotes',
  'HighlighterQuestions',
  'Highlighters',
  'HighlighterStudies',
  'HighlighterSurveys',
  'HighlighterSurveysAdmin',
  'HighlighterTags',
  'MaterializedSurveys',
  'ParticipantGuidance',
  'PointTransaction',
  'Projects',
  'QuestionAssets',
  'RawSurveyData',
  'ReferralCodes',
  'Studies',
  'SurveyInstances',
  'Surveys',
  'Token',
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      postAdminProjectsByProjectIdBoxesBatchCreateByKit: build.mutation<
        PostAdminProjectsByProjectIdBoxesBatchCreateByKitApiResponse,
        PostAdminProjectsByProjectIdBoxesBatchCreateByKitApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/projects/${queryArg.projectId}/boxes/$batchCreateByKit`,
          method: 'POST',
          body: queryArg.batchCreateByKitRequest,
        }),
        invalidatesTags: ['Boxes'],
      }),
      getAdminProjectsByProjectIdBoxes: build.query<
        GetAdminProjectsByProjectIdBoxesApiResponse,
        GetAdminProjectsByProjectIdBoxesApiArg
      >({
        query: (queryArg) => ({ url: `/admin/projects/${queryArg.projectId}/boxes` }),
        providesTags: ['Boxes'],
      }),
      deleteAdminBoxesByBoxId: build.mutation<
        DeleteAdminBoxesByBoxIdApiResponse,
        DeleteAdminBoxesByBoxIdApiArg
      >({
        query: (queryArg) => ({ url: `/admin/boxes/${queryArg.boxId}`, method: 'DELETE' }),
        invalidatesTags: ['Boxes'],
      }),
      getAdminBoxesByBoxId: build.query<
        GetAdminBoxesByBoxIdApiResponse,
        GetAdminBoxesByBoxIdApiArg
      >({
        query: (queryArg) => ({ url: `/admin/boxes/${queryArg.boxId}` }),
        providesTags: ['Boxes'],
      }),
      postAdminBoxesDeliver: build.mutation<
        PostAdminBoxesDeliverApiResponse,
        PostAdminBoxesDeliverApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/boxes/$deliver`,
          method: 'POST',
          body: queryArg.deliverBoxRequest,
        }),
        invalidatesTags: ['Boxes'],
      }),
      getMyChainingBySurveyInstanceId: build.query<
        GetMyChainingBySurveyInstanceIdApiResponse,
        GetMyChainingBySurveyInstanceIdApiArg
      >({
        query: (queryArg) => ({ url: `/my/Chaining/${queryArg.surveyInstanceId}` }),
        providesTags: ['Chaining'],
      }),
      getAdminClients: build.query<GetAdminClientsApiResponse, GetAdminClientsApiArg>({
        query: () => ({ url: `/admin/Clients` }),
        providesTags: ['Clients'],
      }),
      postMyMaterializedSurveysFiles: build.mutation<
        PostMyMaterializedSurveysFilesApiResponse,
        PostMyMaterializedSurveysFilesApiArg
      >({
        query: (queryArg) => ({
          url: `/my/MaterializedSurveys/Files`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['FAKE_TAG_BECAUSE_THIS_ENDPOINT_SHOULD_NOT_INVALIDATE_ANYTHING'],
      }),
      postAdminMaterializedSurveysFiles: build.mutation<
        PostAdminMaterializedSurveysFilesApiResponse,
        PostAdminMaterializedSurveysFilesApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/MaterializedSurveys/Files`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['FAKE_TAG_BECAUSE_THIS_ENDPOINT_SHOULD_NOT_INVALIDATE_ANYTHING'],
      }),
      getAdminSurveysBySurveyIdFunnelSummary: build.query<
        GetAdminSurveysBySurveyIdFunnelSummaryApiResponse,
        GetAdminSurveysBySurveyIdFunnelSummaryApiArg
      >({
        query: (queryArg) => ({ url: `/admin/Surveys/${queryArg.surveyId}/FunnelSummary` }),
        providesTags: ['FunnelSummary'],
      }),
      getMyHighlighterAccounts: build.query<
        GetMyHighlighterAccountsApiResponse,
        GetMyHighlighterAccountsApiArg
      >({
        query: () => ({ url: `/my/highlighterAccounts` }),
        providesTags: ['HighlighterAccounts'],
      }),
      postMyHighlighterAccounts: build.mutation<
        PostMyHighlighterAccountsApiResponse,
        PostMyHighlighterAccountsApiArg
      >({
        query: (queryArg) => ({
          url: `/my/highlighterAccounts`,
          method: 'POST',
          body: queryArg.highlighter,
        }),
        invalidatesTags: ['NewHighlighterAccounts'],
      }),
      putMyHighlighterAccounts: build.mutation<
        PutMyHighlighterAccountsApiResponse,
        PutMyHighlighterAccountsApiArg
      >({
        query: (queryArg) => ({
          url: `/my/HighlighterAccounts`,
          method: 'PUT',
          body: queryArg.highlighter,
        }),
        invalidatesTags: ['HighlighterAccounts'],
      }),
      deleteMyHighlighterAccounts: build.mutation<
        DeleteMyHighlighterAccountsApiResponse,
        DeleteMyHighlighterAccountsApiArg
      >({
        query: () => ({ url: `/my/HighlighterAccounts`, method: 'DELETE' }),
        invalidatesTags: ['HighlighterAccounts'],
      }),
      patchMyHighlighterAccountsEmail: build.mutation<
        PatchMyHighlighterAccountsEmailApiResponse,
        PatchMyHighlighterAccountsEmailApiArg
      >({
        query: (queryArg) => ({
          url: `/my/HighlighterAccounts/email`,
          method: 'PATCH',
          body: queryArg.patchHighlighterEmailRequest,
        }),
        invalidatesTags: ['HighlighterAccounts'],
      }),
      putMyHighlighterAccountsDeactivate: build.mutation<
        PutMyHighlighterAccountsDeactivateApiResponse,
        PutMyHighlighterAccountsDeactivateApiArg
      >({
        query: () => ({ url: `/my/HighlighterAccounts/$deactivate`, method: 'PUT' }),
        invalidatesTags: ['HighlighterAccounts'],
      }),
      postMyHighlighterAccountsBirthdate: build.mutation<
        PostMyHighlighterAccountsBirthdateApiResponse,
        PostMyHighlighterAccountsBirthdateApiArg
      >({
        query: (queryArg) => ({
          url: `/my/HighlighterAccounts/birthdate`,
          method: 'POST',
          body: queryArg.updateHighlighterDateOfBirthRequest,
        }),
        invalidatesTags: ['HighlighterAccounts'],
      }),
      postMyHighlighterAccountsActivateHighlighter: build.mutation<
        PostMyHighlighterAccountsActivateHighlighterApiResponse,
        PostMyHighlighterAccountsActivateHighlighterApiArg
      >({
        query: () => ({ url: `/my/HighlighterAccounts/$activateHighlighter`, method: 'POST' }),
        invalidatesTags: ['HighlighterAccounts'],
      }),
      postMyHighlighterAccountsActivateAccount: build.mutation<
        PostMyHighlighterAccountsActivateAccountApiResponse,
        PostMyHighlighterAccountsActivateAccountApiArg
      >({
        query: () => ({ url: `/my/HighlighterAccounts/$activateAccount`, method: 'POST' }),
        invalidatesTags: ['HighlighterAccounts'],
      }),
      postMyHighlighterAccountsAcceptTos: build.mutation<
        PostMyHighlighterAccountsAcceptTosApiResponse,
        PostMyHighlighterAccountsAcceptTosApiArg
      >({
        query: () => ({ url: `/my/HighlighterAccounts/$acceptTos`, method: 'POST' }),
        invalidatesTags: ['HighlighterAccounts'],
      }),
      getMyHighlighterAccountsGetOnboardingState: build.query<
        GetMyHighlighterAccountsGetOnboardingStateApiResponse,
        GetMyHighlighterAccountsGetOnboardingStateApiArg
      >({
        query: () => ({ url: `/my/HighlighterAccounts/$getOnboardingState` }),
        providesTags: ['HighlighterAccounts'],
      }),
      postHighlighterAccountsSubscriptionSettingsByHighlighterId: build.mutation<
        PostHighlighterAccountsSubscriptionSettingsByHighlighterIdApiResponse,
        PostHighlighterAccountsSubscriptionSettingsByHighlighterIdApiArg
      >({
        query: (queryArg) => ({
          url: `/HighlighterAccounts/subscriptionSettings/${queryArg.highlighterId}`,
          method: 'POST',
          body: queryArg.changeSubscriptionSettingsRequest,
        }),
        invalidatesTags: ['HighlighterAccounts'],
      }),
      getHighlighterAccountsSubscriptionSettingsByHighlighterId: build.query<
        GetHighlighterAccountsSubscriptionSettingsByHighlighterIdApiResponse,
        GetHighlighterAccountsSubscriptionSettingsByHighlighterIdApiArg
      >({
        query: (queryArg) => ({
          url: `/HighlighterAccounts/subscriptionSettings/${queryArg.highlighterId}`,
        }),
        providesTags: ['HighlighterAccounts'],
      }),
      putMyHighlighterAddresses: build.mutation<
        PutMyHighlighterAddressesApiResponse,
        PutMyHighlighterAddressesApiArg
      >({
        query: (queryArg) => ({
          url: `/my/HighlighterAddresses`,
          method: 'PUT',
          body: queryArg.highlighterAddress,
        }),
        invalidatesTags: ['HighlighterAddresses'],
      }),
      postMyHighlighterAddresses: build.mutation<
        PostMyHighlighterAddressesApiResponse,
        PostMyHighlighterAddressesApiArg
      >({
        query: (queryArg) => ({
          url: `/my/HighlighterAddresses`,
          method: 'POST',
          body: queryArg.highlighterAddress,
        }),
        invalidatesTags: ['HighlighterAddresses'],
      }),
      putAdminHighlightersByHighlighterIdAddress: build.mutation<
        PutAdminHighlightersByHighlighterIdAddressApiResponse,
        PutAdminHighlightersByHighlighterIdAddressApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/highlighters/${queryArg.highlighterId}/address`,
          method: 'PUT',
          body: queryArg.highlighterAddress,
          params: {
            bypassValidation: queryArg.bypassValidation,
          },
        }),
        invalidatesTags: ['HighlighterAddresses'],
      }),
      postAdminHighlightersByHighlighterIdAddress: build.mutation<
        PostAdminHighlightersByHighlighterIdAddressApiResponse,
        PostAdminHighlightersByHighlighterIdAddressApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/highlighters/${queryArg.highlighterId}/address`,
          method: 'POST',
          body: queryArg.highlighterAddress,
          params: {
            bypassValidation: queryArg.bypassValidation,
          },
        }),
        invalidatesTags: ['HighlighterAddresses'],
      }),
      getMyHighlighterAnswersSurveysBySurveyInstanceIdAnswers: build.query<
        GetMyHighlighterAnswersSurveysBySurveyInstanceIdAnswersApiResponse,
        GetMyHighlighterAnswersSurveysBySurveyInstanceIdAnswersApiArg
      >({
        query: (queryArg) => ({
          url: `/my/HighlighterAnswers/surveys/${queryArg.surveyInstanceId}/answers`,
        }),
        providesTags: ['HighlighterAnswers'],
      }),
      postMyBoxesReceive: build.mutation<PostMyBoxesReceiveApiResponse, PostMyBoxesReceiveApiArg>({
        query: (queryArg) => ({
          url: `/my/boxes/$receive`,
          method: 'POST',
          body: queryArg.receiveBoxRequest,
        }),
        invalidatesTags: ['HighlighterBoxes'],
      }),
      getMyHighlighterExperiences: build.query<
        GetMyHighlighterExperiencesApiResponse,
        GetMyHighlighterExperiencesApiArg
      >({
        query: () => ({ url: `/my/highlighterExperiences` }),
        providesTags: ['HighlighterExperiences'],
      }),
      postAdminHighlighterGenerationGenerate: build.mutation<
        PostAdminHighlighterGenerationGenerateApiResponse,
        PostAdminHighlighterGenerationGenerateApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/HighlighterGeneration/$generate`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['HighlighterGeneration'],
      }),
      getAdminHighlighterGenerationJobs: build.query<
        GetAdminHighlighterGenerationJobsApiResponse,
        GetAdminHighlighterGenerationJobsApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/HighlighterGeneration/jobs`,
          params: {
            limit: queryArg.limit,
          },
        }),
        providesTags: ['HighlighterGeneration'],
      }),
      getAdminHighlightersByHighlighterIdNotes: build.query<
        GetAdminHighlightersByHighlighterIdNotesApiResponse,
        GetAdminHighlightersByHighlighterIdNotesApiArg
      >({
        query: (queryArg) => ({ url: `/admin/highlighters/${queryArg.highlighterId}/notes` }),
        providesTags: ['HighlighterNotes'],
      }),
      postAdminHighlightersByHighlighterIdNotes: build.mutation<
        PostAdminHighlightersByHighlighterIdNotesApiResponse,
        PostAdminHighlightersByHighlighterIdNotesApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/highlighters/${queryArg.highlighterId}/notes`,
          method: 'POST',
          body: queryArg.highlighterNote,
        }),
        invalidatesTags: ['HighlighterNotes'],
      }),
      postAdminNotes: build.mutation<PostAdminNotesApiResponse, PostAdminNotesApiArg>({
        query: (queryArg) => ({
          url: `/admin/notes`,
          method: 'POST',
          body: queryArg.bulkCreateNoteRequest,
        }),
        invalidatesTags: ['HighlighterNotes'],
      }),
      deleteAdminNotesByNoteId: build.mutation<
        DeleteAdminNotesByNoteIdApiResponse,
        DeleteAdminNotesByNoteIdApiArg
      >({
        query: (queryArg) => ({ url: `/admin/notes/${queryArg.noteId}`, method: 'DELETE' }),
        invalidatesTags: ['HighlighterNotes'],
      }),
      getAdminHighlighterQuestions: build.query<
        GetAdminHighlighterQuestionsApiResponse,
        GetAdminHighlighterQuestionsApiArg
      >({
        query: () => ({ url: `/admin/HighlighterQuestions` }),
        providesTags: ['HighlighterQuestions'],
      }),
      getAdminHighlightersById: build.query<
        GetAdminHighlightersByIdApiResponse,
        GetAdminHighlightersByIdApiArg
      >({
        query: (queryArg) => ({ url: `/admin/Highlighters/${queryArg.id}` }),
        providesTags: ['Highlighters'],
      }),
      getAdminHighlighters: build.query<
        GetAdminHighlightersApiResponse,
        GetAdminHighlightersApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Highlighters`,
          params: {
            CommunitySlug: queryArg.communitySlug,
            Email: queryArg.email,
            FirstName: queryArg.firstName,
            LastName: queryArg.lastName,
            Phone: queryArg.phone,
          },
        }),
        providesTags: ['Highlighters'],
      }),
      deleteAdminHighlighters: build.mutation<
        DeleteAdminHighlightersApiResponse,
        DeleteAdminHighlightersApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Highlighters`,
          method: 'DELETE',
          params: {
            email: queryArg.email,
          },
        }),
        invalidatesTags: ['Highlighters'],
      }),
      postAdminHighlightersBulkGet: build.mutation<
        PostAdminHighlightersBulkGetApiResponse,
        PostAdminHighlightersBulkGetApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Highlighters/$bulkGet`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Highlighters'],
      }),
      postAdminHighlightersBulkGetHighlighters: build.mutation<
        PostAdminHighlightersBulkGetHighlightersApiResponse,
        PostAdminHighlightersBulkGetHighlightersApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Highlighters/$bulkGetHighlighters`,
          method: 'POST',
          body: queryArg.bulkGetHighlightersRequest,
        }),
        invalidatesTags: ['Highlighters'],
      }),
      postAdminHighlightersBulkResolveNotificationContacts: build.mutation<
        PostAdminHighlightersBulkResolveNotificationContactsApiResponse,
        PostAdminHighlightersBulkResolveNotificationContactsApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Highlighters/$bulkResolveNotificationContacts`,
          method: 'POST',
          body: queryArg.bulkResolveNotificationContactsRequest,
        }),
        invalidatesTags: ['Highlighters'],
      }),
      getAdminHighlightersByHighlighterIdGetOnboardingState: build.query<
        GetAdminHighlightersByHighlighterIdGetOnboardingStateApiResponse,
        GetAdminHighlightersByHighlighterIdGetOnboardingStateApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Highlighters/${queryArg.highlighterId}/$getOnboardingState`,
        }),
        providesTags: ['Highlighters'],
      }),
      getAdminHighlightersByHighlighterIdBoxes: build.query<
        GetAdminHighlightersByHighlighterIdBoxesApiResponse,
        GetAdminHighlightersByHighlighterIdBoxesApiArg
      >({
        query: (queryArg) => ({ url: `/admin/Highlighters/${queryArg.highlighterId}/boxes` }),
        providesTags: ['Highlighters'],
      }),
      patchAdminHighlightersByHighlighterId: build.mutation<
        PatchAdminHighlightersByHighlighterIdApiResponse,
        PatchAdminHighlightersByHighlighterIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Highlighters/${queryArg.highlighterId}`,
          method: 'PATCH',
          body: queryArg.patchHighlighterRequest,
        }),
        invalidatesTags: ['Highlighters'],
      }),
      patchAdminHighlightersStatus: build.mutation<
        PatchAdminHighlightersStatusApiResponse,
        PatchAdminHighlightersStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Highlighters/status`,
          method: 'PATCH',
          body: queryArg.patchBulkHighlighterStatusRequest,
        }),
        invalidatesTags: ['Highlighters'],
      }),
      patchAdminHighlightersApplicationStatus: build.mutation<
        PatchAdminHighlightersApplicationStatusApiResponse,
        PatchAdminHighlightersApplicationStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Highlighters/$applicationStatus`,
          method: 'PATCH',
          body: queryArg.manageApplicationStatusRequest,
        }),
        invalidatesTags: ['Highlighters'],
      }),
      patchAdminHighlightersByHighlighterIdDateofbirth: build.mutation<
        PatchAdminHighlightersByHighlighterIdDateofbirthApiResponse,
        PatchAdminHighlightersByHighlighterIdDateofbirthApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Highlighters/${queryArg.highlighterId}/dateofbirth`,
          method: 'PATCH',
          body: queryArg.patchHighlighterDateOfBirthRequest,
        }),
        invalidatesTags: ['Highlighters'],
      }),
      patchAdminHighlightersByHighlighterIdEmail: build.mutation<
        PatchAdminHighlightersByHighlighterIdEmailApiResponse,
        PatchAdminHighlightersByHighlighterIdEmailApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Highlighters/${queryArg.highlighterId}/email`,
          method: 'PATCH',
          body: queryArg.patchHighlighterEmailRequest,
        }),
        invalidatesTags: ['Highlighters'],
      }),
      postAdminHighlightersSendAcceptedIntoStudyEmails: build.mutation<
        PostAdminHighlightersSendAcceptedIntoStudyEmailsApiResponse,
        PostAdminHighlightersSendAcceptedIntoStudyEmailsApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Highlighters/$sendAcceptedIntoStudyEmails`,
          method: 'POST',
          body: queryArg.sendAcceptedIntoStudyEmailsRequest,
        }),
        invalidatesTags: ['Highlighters'],
      }),
      postAdminHighlightersImport: build.mutation<
        PostAdminHighlightersImportApiResponse,
        PostAdminHighlightersImportApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Highlighters/$import`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Highlighters'],
      }),
      getAdminHighlightersGetByReferralCodeByReferralCode: build.query<
        GetAdminHighlightersGetByReferralCodeByReferralCodeApiResponse,
        GetAdminHighlightersGetByReferralCodeByReferralCodeApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Highlighters/$getByReferralCode/${queryArg.referralCode}`,
          params: {
            limit: queryArg.limit,
          },
        }),
        providesTags: ['Highlighters'],
      }),
      getMyStudies: build.query<GetMyStudiesApiResponse, GetMyStudiesApiArg>({
        query: () => ({ url: `/my/studies` }),
        providesTags: ['HighlighterStudies'],
      }),
      getMyProfileSurveys: build.query<GetMyProfileSurveysApiResponse, GetMyProfileSurveysApiArg>({
        query: () => ({ url: `/my/ProfileSurveys` }),
        providesTags: ['HighlighterSurveys'],
      }),
      patchMyHighlighterSurveysBySurveyInstanceId: build.mutation<
        PatchMyHighlighterSurveysBySurveyInstanceIdApiResponse,
        PatchMyHighlighterSurveysBySurveyInstanceIdApiArg
      >({
        query: (queryArg) => ({
          url: `/my/HighlighterSurveys/${queryArg.surveyInstanceId}`,
          method: 'PATCH',
          body: queryArg.patchHighlighterSurveyRequest,
        }),
        invalidatesTags: ['HighlighterSurveys'],
      }),
      postHighlighterSurveysDecline: build.mutation<
        PostHighlighterSurveysDeclineApiResponse,
        PostHighlighterSurveysDeclineApiArg
      >({
        query: (queryArg) => ({
          url: `/highlighterSurveys/$decline`,
          method: 'POST',
          body: queryArg.declineRequest,
        }),
        invalidatesTags: ['HighlighterSurveys'],
      }),
      getAdminHighlightersByHighlighterIdSurveys: build.query<
        GetAdminHighlightersByHighlighterIdSurveysApiResponse,
        GetAdminHighlightersByHighlighterIdSurveysApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/highlighters/${queryArg.highlighterId}/surveys`,
          params: {
            includeOptIns: queryArg.includeOptIns,
          },
        }),
        providesTags: ['HighlighterSurveysAdmin'],
      }),
      getAdminTags: build.query<GetAdminTagsApiResponse, GetAdminTagsApiArg>({
        query: () => ({ url: `/admin/tags` }),
        providesTags: ['HighlighterTags'],
      }),
      getAdminHighlightersByHighlighterIdTags: build.query<
        GetAdminHighlightersByHighlighterIdTagsApiResponse,
        GetAdminHighlightersByHighlighterIdTagsApiArg
      >({
        query: (queryArg) => ({ url: `/admin/highlighters/${queryArg.highlighterId}/tags` }),
        providesTags: ['HighlighterTags'],
      }),
      deleteAdminHighlightersByHighlighterIdTagsAndTagId: build.mutation<
        DeleteAdminHighlightersByHighlighterIdTagsAndTagIdApiResponse,
        DeleteAdminHighlightersByHighlighterIdTagsAndTagIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/highlighters/${queryArg.highlighterId}/tags/${queryArg.tagId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['HighlighterTags'],
      }),
      patchAdminTagsByTagId: build.mutation<
        PatchAdminTagsByTagIdApiResponse,
        PatchAdminTagsByTagIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/tags/${queryArg.tagId}`,
          method: 'PATCH',
          body: queryArg.bulkAssociateTagRequest,
        }),
        invalidatesTags: ['HighlighterTags'],
      }),
      getMyMaterializedSurveysBySurveyInstanceId: build.query<
        GetMyMaterializedSurveysBySurveyInstanceIdApiResponse,
        GetMyMaterializedSurveysBySurveyInstanceIdApiArg
      >({
        query: (queryArg) => ({ url: `/my/MaterializedSurveys/${queryArg.surveyInstanceId}` }),
        providesTags: ['MaterializedSurveys'],
      }),
      postMyMaterializedSurveysResponses: build.mutation<
        PostMyMaterializedSurveysResponsesApiResponse,
        PostMyMaterializedSurveysResponsesApiArg
      >({
        query: (queryArg) => ({
          url: `/my/MaterializedSurveys/Responses`,
          method: 'POST',
          body: queryArg.vendorSurveyResponse,
          params: {
            surveyInstanceId: queryArg.surveyInstanceId,
          },
        }),
        invalidatesTags: ['MaterializedSurveys'],
      }),
      postMyHighlighterAccountsGuest: build.mutation<
        PostMyHighlighterAccountsGuestApiResponse,
        PostMyHighlighterAccountsGuestApiArg
      >({
        query: (queryArg) => ({
          url: `/my/highlighterAccounts/$guest`,
          method: 'POST',
          body: queryArg.createGuestHighlighterRequest,
        }),
        invalidatesTags: ['NewHighlighterAccounts'],
      }),
      putAdminParticipantGuidance: build.mutation<
        PutAdminParticipantGuidanceApiResponse,
        PutAdminParticipantGuidanceApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/ParticipantGuidance`,
          method: 'PUT',
          body: queryArg.turnOffParticipantGuidanceRequest,
        }),
        invalidatesTags: ['ParticipantGuidance'],
      }),
      postAdminPointTransactionBulk: build.mutation<
        PostAdminPointTransactionBulkApiResponse,
        PostAdminPointTransactionBulkApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/PointTransaction/bulk`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['PointTransaction'],
      }),
      getAdminHighlightersByHighlighterIdPointTransaction: build.query<
        GetAdminHighlightersByHighlighterIdPointTransactionApiResponse,
        GetAdminHighlightersByHighlighterIdPointTransactionApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/highlighters/${queryArg.highlighterId}/PointTransaction`,
        }),
        providesTags: ['PointTransaction'],
      }),
      postAdminPointTransactionGetRewardsCsv: build.mutation<
        PostAdminPointTransactionGetRewardsCsvApiResponse,
        PostAdminPointTransactionGetRewardsCsvApiArg
      >({
        query: () => ({ url: `/admin/PointTransaction/$getRewardsCsv`, method: 'POST' }),
        invalidatesTags: ['PointTransaction'],
      }),
      getAdminPointTransactionGetRewardsEstimate: build.query<
        GetAdminPointTransactionGetRewardsEstimateApiResponse,
        GetAdminPointTransactionGetRewardsEstimateApiArg
      >({
        query: () => ({ url: `/admin/PointTransaction/$getRewardsEstimate` }),
        providesTags: ['PointTransaction'],
      }),
      getAdminPointTransaction: build.query<
        GetAdminPointTransactionApiResponse,
        GetAdminPointTransactionApiArg
      >({
        query: () => ({ url: `/admin/PointTransaction` }),
        providesTags: ['PointTransaction'],
      }),
      getAdminProjectsByIdSurveys: build.query<
        GetAdminProjectsByIdSurveysApiResponse,
        GetAdminProjectsByIdSurveysApiArg
      >({
        query: (queryArg) => ({ url: `/admin/Projects/${queryArg.id}/surveys` }),
        providesTags: ['Projects'],
      }),
      getMyHighlighterSurveysBySurveyInstanceIdQuestionAssets: build.query<
        GetMyHighlighterSurveysBySurveyInstanceIdQuestionAssetsApiResponse,
        GetMyHighlighterSurveysBySurveyInstanceIdQuestionAssetsApiArg
      >({
        query: (queryArg) => ({
          url: `/my/HighlighterSurveys/${queryArg.surveyInstanceId}/QuestionAssets`,
        }),
        providesTags: ['QuestionAssets'],
      }),
      putMyRawSurveyDataBySurveyInstanceId: build.mutation<
        PutMyRawSurveyDataBySurveyInstanceIdApiResponse,
        PutMyRawSurveyDataBySurveyInstanceIdApiArg
      >({
        query: (queryArg) => ({
          url: `/my/RawSurveyData/${queryArg.surveyInstanceId}`,
          method: 'PUT',
          body: queryArg.rawSurveyDataRequest,
        }),
        invalidatesTags: ['RawSurveyData'],
      }),
      getAdminReferralCodes: build.query<
        GetAdminReferralCodesApiResponse,
        GetAdminReferralCodesApiArg
      >({
        query: () => ({ url: `/admin/ReferralCodes` }),
        providesTags: ['ReferralCodes'],
      }),
      postAdminReferralCodes: build.mutation<
        PostAdminReferralCodesApiResponse,
        PostAdminReferralCodesApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/ReferralCodes`,
          method: 'POST',
          body: queryArg.referralCode,
        }),
        invalidatesTags: ['ReferralCodes'],
      }),
      getAdminReferralCodesById: build.query<
        GetAdminReferralCodesByIdApiResponse,
        GetAdminReferralCodesByIdApiArg
      >({
        query: (queryArg) => ({ url: `/admin/ReferralCodes/${queryArg.id}` }),
        providesTags: ['ReferralCodes'],
      }),
      putAdminReferralCodesByReferralCodeId: build.mutation<
        PutAdminReferralCodesByReferralCodeIdApiResponse,
        PutAdminReferralCodesByReferralCodeIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/ReferralCodes/${queryArg.referralCodeId}`,
          method: 'PUT',
          body: queryArg.referralCode,
        }),
        invalidatesTags: ['ReferralCodes'],
      }),
      postAdminReferralCodesBatchCreate: build.mutation<
        PostAdminReferralCodesBatchCreateApiResponse,
        PostAdminReferralCodesBatchCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/ReferralCodes/batchCreate`,
          method: 'POST',
          body: queryArg.body,
          params: {
            limit: queryArg.limit,
            prefix: queryArg.prefix,
          },
        }),
        invalidatesTags: ['ReferralCodes'],
      }),
      getAdminStudiesByHighlighterId: build.query<
        GetAdminStudiesByHighlighterIdApiResponse,
        GetAdminStudiesByHighlighterIdApiArg
      >({
        query: (queryArg) => ({ url: `/admin/Studies/${queryArg.highlighterId}` }),
        providesTags: ['Studies'],
      }),
      postAdminSurveysBySurveyIdSurveyInstances: build.mutation<
        PostAdminSurveysBySurveyIdSurveyInstancesApiResponse,
        PostAdminSurveysBySurveyIdSurveyInstancesApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Surveys/${queryArg.surveyId}/SurveyInstances`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['SurveyInstances'],
      }),
      getAdminSurveysBySurveyIdSurveyInstances: build.query<
        GetAdminSurveysBySurveyIdSurveyInstancesApiResponse,
        GetAdminSurveysBySurveyIdSurveyInstancesApiArg
      >({
        query: (queryArg) => ({ url: `/admin/Surveys/${queryArg.surveyId}/SurveyInstances` }),
        providesTags: ['SurveyInstances'],
      }),
      putAdminSurveysBySurveyIdSurveyInstancesHiddenVariables: build.mutation<
        PutAdminSurveysBySurveyIdSurveyInstancesHiddenVariablesApiResponse,
        PutAdminSurveysBySurveyIdSurveyInstancesHiddenVariablesApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Surveys/${queryArg.surveyId}/SurveyInstances/$hiddenVariables`,
          method: 'PUT',
          body: queryArg.body,
        }),
        invalidatesTags: ['SurveyInstances'],
      }),
      postAdminSurveyInstancesBulkCreate: build.mutation<
        PostAdminSurveyInstancesBulkCreateApiResponse,
        PostAdminSurveyInstancesBulkCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/SurveyInstances/$bulkCreate`,
          method: 'POST',
          body: queryArg.bulkInstancesRequest,
        }),
        invalidatesTags: ['SurveyInstances'],
      }),
      postAdminSurveysSurveyInstancesBatchCreateAndSend: build.mutation<
        PostAdminSurveysSurveyInstancesBatchCreateAndSendApiResponse,
        PostAdminSurveysSurveyInstancesBatchCreateAndSendApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Surveys/SurveyInstances/$batchCreateAndSend`,
          method: 'POST',
          body: queryArg.batchCreateAndSendRequest,
        }),
        invalidatesTags: ['SurveyInstances'],
      }),
      patchAdminSurveyInstancesBySurveyInstanceId: build.mutation<
        PatchAdminSurveyInstancesBySurveyInstanceIdApiResponse,
        PatchAdminSurveyInstancesBySurveyInstanceIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/SurveyInstances/${queryArg.surveyInstanceId}`,
          method: 'PATCH',
          body: queryArg.patchSurveyInstanceRequest,
        }),
        invalidatesTags: ['SurveyInstances'],
      }),
      getAdminSurveyInstancesBySurveyInstanceId: build.query<
        GetAdminSurveyInstancesBySurveyInstanceIdApiResponse,
        GetAdminSurveyInstancesBySurveyInstanceIdApiArg
      >({
        query: (queryArg) => ({ url: `/admin/SurveyInstances/${queryArg.surveyInstanceId}` }),
        providesTags: ['SurveyInstances'],
      }),
      patchAdminSurveyInstancesBySurveyInstanceIdDeadline: build.mutation<
        PatchAdminSurveyInstancesBySurveyInstanceIdDeadlineApiResponse,
        PatchAdminSurveyInstancesBySurveyInstanceIdDeadlineApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/SurveyInstances/${queryArg.surveyInstanceId}/deadline`,
          method: 'PATCH',
          body: queryArg.updateSurveyInstanceDeadlineRequest,
        }),
        invalidatesTags: ['SurveyInstances'],
      }),
      getAdminSurveyInstances: build.query<
        GetAdminSurveyInstancesApiResponse,
        GetAdminSurveyInstancesApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/SurveyInstances`,
          params: {
            boxId: queryArg.boxId,
            surveyType: queryArg.surveyType,
          },
        }),
        providesTags: ['SurveyInstances'],
      }),
      postAdminSurveyInstancesNotifyClientParticipantsOfSurveys: build.mutation<
        PostAdminSurveyInstancesNotifyClientParticipantsOfSurveysApiResponse,
        PostAdminSurveyInstancesNotifyClientParticipantsOfSurveysApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/SurveyInstances/$notifyClientParticipantsOfSurveys`,
          method: 'POST',
          body: queryArg.notifyClientParticipantsRequest,
        }),
        invalidatesTags: ['SurveyInstances'],
      }),
      getAdminSurveyInstancesCountsByProjectByProjectId: build.query<
        GetAdminSurveyInstancesCountsByProjectByProjectIdApiResponse,
        GetAdminSurveyInstancesCountsByProjectByProjectIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/SurveyInstances/counts-by-project/${queryArg.projectId}`,
        }),
        providesTags: ['SurveyInstances'],
      }),
      postAdminSurveys: build.mutation<PostAdminSurveysApiResponse, PostAdminSurveysApiArg>({
        query: (queryArg) => ({ url: `/admin/Surveys`, method: 'POST', body: queryArg.survey }),
        invalidatesTags: ['Surveys'],
      }),
      putAdminSurveys: build.mutation<PutAdminSurveysApiResponse, PutAdminSurveysApiArg>({
        query: (queryArg) => ({ url: `/admin/Surveys`, method: 'PUT', body: queryArg.survey }),
        invalidatesTags: ['Surveys'],
      }),
      getAdminSurveys: build.query<GetAdminSurveysApiResponse, GetAdminSurveysApiArg>({
        query: (queryArg) => ({
          url: `/admin/Surveys`,
          params: {
            projectId: queryArg.projectId,
          },
        }),
        providesTags: ['Surveys'],
      }),
      putAdminSurveysById: build.mutation<
        PutAdminSurveysByIdApiResponse,
        PutAdminSurveysByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Surveys/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.survey,
        }),
        invalidatesTags: ['Surveys'],
      }),
      getAdminSurveysById: build.query<GetAdminSurveysByIdApiResponse, GetAdminSurveysByIdApiArg>({
        query: (queryArg) => ({ url: `/admin/Surveys/${queryArg.id}` }),
        providesTags: ['Surveys'],
      }),
      postAdminSurveysBulkGetByIds: build.mutation<
        PostAdminSurveysBulkGetByIdsApiResponse,
        PostAdminSurveysBulkGetByIdsApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Surveys/$bulkGetByIds`,
          method: 'POST',
          body: queryArg.bulkGetSurveysRequest,
        }),
        invalidatesTags: ['Surveys'],
      }),
      postAdminSurveysGetFromLinkUrls: build.mutation<
        PostAdminSurveysGetFromLinkUrlsApiResponse,
        PostAdminSurveysGetFromLinkUrlsApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Surveys/$getFromLinkUrls`,
          method: 'POST',
          body: queryArg.getSurveyByLinkUrlsRequest,
        }),
        invalidatesTags: ['Surveys'],
      }),
      postAdminSurveysGetSurveysFromLinkUrls: build.mutation<
        PostAdminSurveysGetSurveysFromLinkUrlsApiResponse,
        PostAdminSurveysGetSurveysFromLinkUrlsApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Surveys/$getSurveysFromLinkUrls`,
          method: 'POST',
          body: queryArg.getSurveyByLinkUrlsRequest,
        }),
        invalidatesTags: ['Surveys'],
      }),
      putAdminSurveysBySurveyIdActions: build.mutation<
        PutAdminSurveysBySurveyIdActionsApiResponse,
        PutAdminSurveysBySurveyIdActionsApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Surveys/${queryArg.surveyId}/actions`,
          method: 'PUT',
          body: queryArg.surveyActionRequest,
        }),
        invalidatesTags: ['Surveys'],
      }),
      postAdminSurveysByProfileSurveyIdSendprofilesurvey: build.mutation<
        PostAdminSurveysByProfileSurveyIdSendprofilesurveyApiResponse,
        PostAdminSurveysByProfileSurveyIdSendprofilesurveyApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Surveys/${queryArg.profileSurveyId}/$sendprofilesurvey`,
          method: 'POST',
        }),
        invalidatesTags: ['Surveys'],
      }),
      postAdminSurveysBySurveyIdSenditemsurvey: build.mutation<
        PostAdminSurveysBySurveyIdSenditemsurveyApiResponse,
        PostAdminSurveysBySurveyIdSenditemsurveyApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Surveys/${queryArg.surveyId}/$senditemsurvey`,
          method: 'POST',
          body: queryArg.highlighterIdsRequest,
        }),
        invalidatesTags: ['Surveys'],
      }),
      postAdminSurveysBySurveyIdNudge: build.mutation<
        PostAdminSurveysBySurveyIdNudgeApiResponse,
        PostAdminSurveysBySurveyIdNudgeApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Surveys/${queryArg.surveyId}/$nudge`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Surveys'],
      }),
      postAdminSurveysBySurveyIdFailedQc: build.mutation<
        PostAdminSurveysBySurveyIdFailedQcApiResponse,
        PostAdminSurveysBySurveyIdFailedQcApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Surveys/${queryArg.surveyId}/$failedQC`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Surveys'],
      }),
      getAdminSurveysBySurveyIdPreviewNudge: build.query<
        GetAdminSurveysBySurveyIdPreviewNudgeApiResponse,
        GetAdminSurveysBySurveyIdPreviewNudgeApiArg
      >({
        query: (queryArg) => ({ url: `/admin/Surveys/${queryArg.surveyId}/$previewNudge` }),
        providesTags: ['Surveys'],
      }),
      getAdminSurveysBySurveyIdSurveyInstanceStatusCounts: build.query<
        GetAdminSurveysBySurveyIdSurveyInstanceStatusCountsApiResponse,
        GetAdminSurveysBySurveyIdSurveyInstanceStatusCountsApiArg
      >({
        query: (queryArg) => ({
          url: `/admin/Surveys/${queryArg.surveyId}/$surveyInstanceStatusCounts`,
        }),
        providesTags: ['Surveys'],
      }),
      postAuthToken: build.mutation<PostAuthTokenApiResponse, PostAuthTokenApiArg>({
        query: (queryArg) => ({ url: `/auth/token`, method: 'POST', body: queryArg.tokenRequest }),
        invalidatesTags: ['Token'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as highlighterApi };
export type PostAdminProjectsByProjectIdBoxesBatchCreateByKitApiResponse =
  /** status 200 Success */ Box[];
export type PostAdminProjectsByProjectIdBoxesBatchCreateByKitApiArg = {
  /** The Client Portal's Project ID */
  projectId: number;
  /** Contains the list of Highlighter IDs and Kit ID to create boxes for */
  batchCreateByKitRequest: BatchCreateByKitRequest;
};
export type GetAdminProjectsByProjectIdBoxesApiResponse = /** status 200 Success */ Box[];
export type GetAdminProjectsByProjectIdBoxesApiArg = {
  /** The Client Portal's Project Id (client.client_portal_id in this db) */
  projectId: number;
};
export type DeleteAdminBoxesByBoxIdApiResponse = unknown;
export type DeleteAdminBoxesByBoxIdApiArg = {
  /** The ID of a Box without a tracking number */
  boxId: string;
};
export type GetAdminBoxesByBoxIdApiResponse = /** status 200 Success */ Box;
export type GetAdminBoxesByBoxIdApiArg = {
  boxId: string;
};
export type PostAdminBoxesDeliverApiResponse =
  /** status 200 Success */ DeliveryResultItemBatchOperationResult;
export type PostAdminBoxesDeliverApiArg = {
  deliverBoxRequest: DeliverBoxRequest;
};
export type GetMyChainingBySurveyInstanceIdApiResponse =
  /** status 200 Success */ ChainResponseRead;
export type GetMyChainingBySurveyInstanceIdApiArg = {
  surveyInstanceId: string;
};
export type GetAdminClientsApiResponse = /** status 200 Success */ Client[];
export type GetAdminClientsApiArg = void;
export type PostMyMaterializedSurveysFilesApiResponse = /** status 200 Success */ string;
export type PostMyMaterializedSurveysFilesApiArg = {
  body: {
    ContentType?: string;
    ContentDisposition?: string;
    Headers?: {
      [key: string]: string[];
    };
    Length?: number;
    Name?: string;
    FileName?: string;
  };
};
export type PostAdminMaterializedSurveysFilesApiResponse = /** status 200 Success */ string;
export type PostAdminMaterializedSurveysFilesApiArg = {
  body: {
    ContentType?: string;
    ContentDisposition?: string;
    Headers?: {
      [key: string]: string[];
    };
    Length?: number;
    Name?: string;
    FileName?: string;
  };
};
export type GetAdminSurveysBySurveyIdFunnelSummaryApiResponse =
  /** status 200 Success */ FunnelSummaryResponse;
export type GetAdminSurveysBySurveyIdFunnelSummaryApiArg = {
  surveyId: string;
};
export type GetMyHighlighterAccountsApiResponse = /** status 200 Success */ Highlighter;
export type GetMyHighlighterAccountsApiArg = void;
export type PostMyHighlighterAccountsApiResponse = /** status 200 Success */ Highlighter;
export type PostMyHighlighterAccountsApiArg = {
  highlighter: Highlighter;
};
export type PutMyHighlighterAccountsApiResponse = unknown;
export type PutMyHighlighterAccountsApiArg = {
  highlighter: Highlighter;
};
export type DeleteMyHighlighterAccountsApiResponse = unknown;
export type DeleteMyHighlighterAccountsApiArg = void;
export type PatchMyHighlighterAccountsEmailApiResponse = unknown;
export type PatchMyHighlighterAccountsEmailApiArg = {
  patchHighlighterEmailRequest: PatchHighlighterEmailRequest;
};
export type PutMyHighlighterAccountsDeactivateApiResponse = unknown;
export type PutMyHighlighterAccountsDeactivateApiArg = void;
export type PostMyHighlighterAccountsBirthdateApiResponse = /** status 200 Success */ string;
export type PostMyHighlighterAccountsBirthdateApiArg = {
  updateHighlighterDateOfBirthRequest: UpdateHighlighterDateOfBirthRequest;
};
export type PostMyHighlighterAccountsActivateHighlighterApiResponse =
  /** status 200 Success */ ActivateHighlighterResponseRead;
export type PostMyHighlighterAccountsActivateHighlighterApiArg = void;
export type PostMyHighlighterAccountsActivateAccountApiResponse =
  /** status 200 Success */ ActivateAccountResponse;
export type PostMyHighlighterAccountsActivateAccountApiArg = void;
export type PostMyHighlighterAccountsAcceptTosApiResponse = /** status 200 Success */ string;
export type PostMyHighlighterAccountsAcceptTosApiArg = void;
export type GetMyHighlighterAccountsGetOnboardingStateApiResponse =
  /** status 200 Success */ OnboardingStateResponseRead;
export type GetMyHighlighterAccountsGetOnboardingStateApiArg = void;
export type PostHighlighterAccountsSubscriptionSettingsByHighlighterIdApiResponse = unknown;
export type PostHighlighterAccountsSubscriptionSettingsByHighlighterIdApiArg = {
  highlighterId: string;
  changeSubscriptionSettingsRequest: ChangeSubscriptionSettingsRequest;
};
export type GetHighlighterAccountsSubscriptionSettingsByHighlighterIdApiResponse =
  /** status 200 Success */ HighlighterSubscriptionSettings;
export type GetHighlighterAccountsSubscriptionSettingsByHighlighterIdApiArg = {
  highlighterId: string;
};
export type PutMyHighlighterAddressesApiResponse = unknown;
export type PutMyHighlighterAddressesApiArg = {
  highlighterAddress: HighlighterAddress;
};
export type PostMyHighlighterAddressesApiResponse = unknown;
export type PostMyHighlighterAddressesApiArg = {
  highlighterAddress: HighlighterAddress;
};
export type PutAdminHighlightersByHighlighterIdAddressApiResponse = unknown;
export type PutAdminHighlightersByHighlighterIdAddressApiArg = {
  highlighterId: string;
  /** If true, skips address validation with third-party provider */
  bypassValidation?: boolean;
  highlighterAddress: HighlighterAddress;
};
export type PostAdminHighlightersByHighlighterIdAddressApiResponse = unknown;
export type PostAdminHighlightersByHighlighterIdAddressApiArg = {
  highlighterId: string;
  /** If true, skips address validation with third-party provider */
  bypassValidation?: boolean;
  highlighterAddress: HighlighterAddress;
};
export type GetMyHighlighterAnswersSurveysBySurveyInstanceIdAnswersApiResponse =
  /** status 200 Success */ ProfileAnswers[];
export type GetMyHighlighterAnswersSurveysBySurveyInstanceIdAnswersApiArg = {
  surveyInstanceId: string;
};
export type PostMyBoxesReceiveApiResponse = /** status 200 Success */ DeliveryResultItem;
export type PostMyBoxesReceiveApiArg = {
  receiveBoxRequest: ReceiveBoxRequest;
};
export type GetMyHighlighterExperiencesApiResponse =
  /** status 200 Success */ HighlighterStudyV10[];
export type GetMyHighlighterExperiencesApiArg = void;
export type PostAdminHighlighterGenerationGenerateApiResponse =
  /** status 200 Success */ StartGenerationResponse;
export type PostAdminHighlighterGenerationGenerateApiArg = {
  body: {
    file?: Blob;
    useDefaultCsv?: boolean;
    count?: number;
    referralCode?: string;
    communitySlug?: string;
  };
};
export type GetAdminHighlighterGenerationJobsApiResponse =
  /** status 200 Success */ HighlighterGenerationJobStatus[];
export type GetAdminHighlighterGenerationJobsApiArg = {
  /** Maximum number of jobs to return (default: 100). */
  limit?: number;
};
export type GetAdminHighlightersByHighlighterIdNotesApiResponse =
  /** status 200 Success */ HighlighterNote[];
export type GetAdminHighlightersByHighlighterIdNotesApiArg = {
  /** The ID of the highlighter. */
  highlighterId: string;
};
export type PostAdminHighlightersByHighlighterIdNotesApiResponse =
  /** status 200 Success */ HighlighterNote;
export type PostAdminHighlightersByHighlighterIdNotesApiArg = {
  highlighterId: string;
  highlighterNote: HighlighterNote;
};
export type PostAdminNotesApiResponse = /** status 200 Success */ BulkCreateNoteResponse;
export type PostAdminNotesApiArg = {
  bulkCreateNoteRequest: BulkCreateNoteRequest;
};
export type DeleteAdminNotesByNoteIdApiResponse = unknown;
export type DeleteAdminNotesByNoteIdApiArg = {
  noteId: string;
};
export type GetAdminHighlighterQuestionsApiResponse =
  /** status 200 Success */ HighlighterQuestion[];
export type GetAdminHighlighterQuestionsApiArg = void;
export type GetAdminHighlightersByIdApiResponse = /** status 200 Success */ Highlighter;
export type GetAdminHighlightersByIdApiArg = {
  /** The ID of the highlighter to retrieve. */
  id: string;
};
export type GetAdminHighlightersApiResponse = /** status 200 Success */ Highlighter[];
export type GetAdminHighlightersApiArg = {
  communitySlug?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
};
export type DeleteAdminHighlightersApiResponse = /** status 200 Success */ Highlighter;
export type DeleteAdminHighlightersApiArg = {
  email?: string;
};
export type PostAdminHighlightersBulkGetApiResponse = /** status 200 Success */ Highlighter[];
export type PostAdminHighlightersBulkGetApiArg = {
  /** The ID of the highlighter to retrieve. */
  body: string[];
};
export type PostAdminHighlightersBulkGetHighlightersApiResponse =
  /** status 200 Success */ Highlighter[];
export type PostAdminHighlightersBulkGetHighlightersApiArg = {
  bulkGetHighlightersRequest: BulkGetHighlightersRequest;
};
export type PostAdminHighlightersBulkResolveNotificationContactsApiResponse =
  /** status 200 Success */ NotificationHighlighterContact[];
export type PostAdminHighlightersBulkResolveNotificationContactsApiArg = {
  bulkResolveNotificationContactsRequest: BulkResolveNotificationContactsRequest;
};
export type GetAdminHighlightersByHighlighterIdGetOnboardingStateApiResponse =
  /** status 200 Success */ OnboardingStateResponseRead;
export type GetAdminHighlightersByHighlighterIdGetOnboardingStateApiArg = {
  highlighterId: string;
};
export type GetAdminHighlightersByHighlighterIdBoxesApiResponse = /** status 200 Success */ Box[];
export type GetAdminHighlightersByHighlighterIdBoxesApiArg = {
  highlighterId: string;
};
export type PatchAdminHighlightersByHighlighterIdApiResponse =
  /** status 200 Success */ Highlighter;
export type PatchAdminHighlightersByHighlighterIdApiArg = {
  highlighterId: string;
  patchHighlighterRequest: PatchHighlighterRequest;
};
export type PatchAdminHighlightersStatusApiResponse = /** status 200 Success */ number;
export type PatchAdminHighlightersStatusApiArg = {
  patchBulkHighlighterStatusRequest: PatchBulkHighlighterStatusRequest;
};
export type PatchAdminHighlightersApplicationStatusApiResponse = unknown;
export type PatchAdminHighlightersApplicationStatusApiArg = {
  manageApplicationStatusRequest: ManageApplicationStatusRequest;
};
export type PatchAdminHighlightersByHighlighterIdDateofbirthApiResponse =
  /** status 200 Success */ Highlighter;
export type PatchAdminHighlightersByHighlighterIdDateofbirthApiArg = {
  highlighterId: string;
  patchHighlighterDateOfBirthRequest: PatchHighlighterDateOfBirthRequest;
};
export type PatchAdminHighlightersByHighlighterIdEmailApiResponse =
  /** status 200 Success */ Highlighter;
export type PatchAdminHighlightersByHighlighterIdEmailApiArg = {
  highlighterId: string;
  patchHighlighterEmailRequest: PatchHighlighterEmailRequest;
};
export type PostAdminHighlightersSendAcceptedIntoStudyEmailsApiResponse =
  /** status 200 Success */ string[];
export type PostAdminHighlightersSendAcceptedIntoStudyEmailsApiArg = {
  sendAcceptedIntoStudyEmailsRequest: SendAcceptedIntoStudyEmailsRequest;
};
export type PostAdminHighlightersImportApiResponse =
  /** status 200 Success */ HighlighterBulkCreateResultItemBatchOperationResultRead;
export type PostAdminHighlightersImportApiArg = {
  body: {
    referralCode?: string;
    communitySlug?: string;
    file?: Blob;
  };
};
export type GetAdminHighlightersGetByReferralCodeByReferralCodeApiResponse =
  /** status 200 Success */ string[];
export type GetAdminHighlightersGetByReferralCodeByReferralCodeApiArg = {
  /** The referral code to query */
  referralCode: string;
  /** Maximum number of highlighter IDs to return (default: 1000) */
  limit?: number;
};
export type GetMyStudiesApiResponse = /** status 200 Success */ HighlighterStudyRead[];
export type GetMyStudiesApiArg = void;
export type GetMyProfileSurveysApiResponse = /** status 200 Success */ ProfileSurveyRead[];
export type GetMyProfileSurveysApiArg = void;
export type PatchMyHighlighterSurveysBySurveyInstanceIdApiResponse = unknown;
export type PatchMyHighlighterSurveysBySurveyInstanceIdApiArg = {
  surveyInstanceId: string;
  patchHighlighterSurveyRequest: PatchHighlighterSurveyRequest;
};
export type PostHighlighterSurveysDeclineApiResponse = unknown;
export type PostHighlighterSurveysDeclineApiArg = {
  declineRequest: DeclineRequest;
};
export type GetAdminHighlightersByHighlighterIdSurveysApiResponse =
  /** status 200 Success */ HighlighterSurveyAdminRead[];
export type GetAdminHighlightersByHighlighterIdSurveysApiArg = {
  /** The ID of the highlighter. */
  highlighterId: string;
  /** To include opt ins */
  includeOptIns?: boolean;
};
export type GetAdminTagsApiResponse = /** status 200 Success */ HighlighterTag[];
export type GetAdminTagsApiArg = void;
export type GetAdminHighlightersByHighlighterIdTagsApiResponse =
  /** status 200 Success */ HighlighterTag[];
export type GetAdminHighlightersByHighlighterIdTagsApiArg = {
  /** The ID of the highlighter */
  highlighterId: string;
};
export type DeleteAdminHighlightersByHighlighterIdTagsAndTagIdApiResponse = unknown;
export type DeleteAdminHighlightersByHighlighterIdTagsAndTagIdApiArg = {
  highlighterId: string;
  tagId: string;
};
export type PatchAdminTagsByTagIdApiResponse = /** status 200 Success */ BulkAssociateTagResponse;
export type PatchAdminTagsByTagIdApiArg = {
  tagId: string;
  bulkAssociateTagRequest: BulkAssociateTagRequest;
};
export type GetMyMaterializedSurveysBySurveyInstanceIdApiResponse =
  /** status 200 Success */ MaterializedSurveyDto;
export type GetMyMaterializedSurveysBySurveyInstanceIdApiArg = {
  /** The id of the survey instance */
  surveyInstanceId: string;
};
export type PostMyMaterializedSurveysResponsesApiResponse = unknown;
export type PostMyMaterializedSurveysResponsesApiArg = {
  surveyInstanceId?: string;
  vendorSurveyResponse: VendorSurveyResponse;
};
export type PostMyHighlighterAccountsGuestApiResponse = /** status 200 Success */ Highlighter;
export type PostMyHighlighterAccountsGuestApiArg = {
  createGuestHighlighterRequest: CreateGuestHighlighterRequest;
};
export type PutAdminParticipantGuidanceApiResponse = unknown;
export type PutAdminParticipantGuidanceApiArg = {
  turnOffParticipantGuidanceRequest: TurnOffParticipantGuidanceRequest;
};
export type PostAdminPointTransactionBulkApiResponse = /** status 200 Success */ PointTransaction[];
export type PostAdminPointTransactionBulkApiArg = {
  body: PointTransaction[];
};
export type GetAdminHighlightersByHighlighterIdPointTransactionApiResponse =
  /** status 200 Success */ HighlighterPoints;
export type GetAdminHighlightersByHighlighterIdPointTransactionApiArg = {
  highlighterId: string;
};
export type PostAdminPointTransactionGetRewardsCsvApiResponse = unknown;
export type PostAdminPointTransactionGetRewardsCsvApiArg = void;
export type GetAdminPointTransactionGetRewardsEstimateApiResponse =
  /** status 200 Success */ HighlighterRewardsEstimate;
export type GetAdminPointTransactionGetRewardsEstimateApiArg = void;
export type GetAdminPointTransactionApiResponse = /** status 200 Success */ PointTransaction[];
export type GetAdminPointTransactionApiArg = void;
export type GetAdminProjectsByIdSurveysApiResponse = /** status 200 Success */ Survey[];
export type GetAdminProjectsByIdSurveysApiArg = {
  id: number;
};
export type GetMyHighlighterSurveysBySurveyInstanceIdQuestionAssetsApiResponse =
  /** status 200 Success */ QuestionAsset[];
export type GetMyHighlighterSurveysBySurveyInstanceIdQuestionAssetsApiArg = {
  surveyInstanceId: string;
};
export type PutMyRawSurveyDataBySurveyInstanceIdApiResponse =
  /** status 200 Success */ RawSurveyData;
export type PutMyRawSurveyDataBySurveyInstanceIdApiArg = {
  /** The id of the survey instance whose state is being saved. */
  surveyInstanceId: string;
  /** The raw SurveyJS state payload. */
  rawSurveyDataRequest: RawSurveyDataRequest;
};
export type GetAdminReferralCodesApiResponse = /** status 200 Success */ ReferralCode[];
export type GetAdminReferralCodesApiArg = void;
export type PostAdminReferralCodesApiResponse = /** status 200 Success */ ReferralCode;
export type PostAdminReferralCodesApiArg = {
  referralCode: ReferralCode;
};
export type GetAdminReferralCodesByIdApiResponse = /** status 200 Success */ ReferralCode;
export type GetAdminReferralCodesByIdApiArg = {
  id: string;
};
export type PutAdminReferralCodesByReferralCodeIdApiResponse =
  /** status 200 Success */ ReferralCode;
export type PutAdminReferralCodesByReferralCodeIdApiArg = {
  referralCodeId: string;
  referralCode: ReferralCode;
};
export type PostAdminReferralCodesBatchCreateApiResponse =
  /** status 200 Success */ BatchCreateReferralCodesResult;
export type PostAdminReferralCodesBatchCreateApiArg = {
  /** Maximum number of highlighters to process (default: 1000). Pass null to process all. Ignored if file is provided. */
  limit?: number;
  /** Required prefix to prepend to all generated codes (separated by hyphen) */
  prefix?: string;
  body: {
    ContentType?: string;
    ContentDisposition?: string;
    Headers?: {
      [key: string]: string[];
    };
    Length?: number;
    Name?: string;
    FileName?: string;
  };
};
export type GetAdminStudiesByHighlighterIdApiResponse =
  /** status 200 Success */ HighlighterStudyRead[];
export type GetAdminStudiesByHighlighterIdApiArg = {
  highlighterId: string;
};
export type PostAdminSurveysBySurveyIdSurveyInstancesApiResponse =
  /** status 200 Success */ CreateSurveyInstanceResult;
export type PostAdminSurveysBySurveyIdSurveyInstancesApiArg = {
  surveyId: string;
  body: {
    ContentType?: string;
    ContentDisposition?: string;
    Headers?: {
      [key: string]: string[];
    };
    Length?: number;
    Name?: string;
    FileName?: string;
  };
};
export type GetAdminSurveysBySurveyIdSurveyInstancesApiResponse =
  /** status 200 Success */ SurveyInstanceRead[];
export type GetAdminSurveysBySurveyIdSurveyInstancesApiArg = {
  surveyId: string;
};
export type PutAdminSurveysBySurveyIdSurveyInstancesHiddenVariablesApiResponse =
  /** status 200 Success */ SurveyInstanceResponse[];
export type PutAdminSurveysBySurveyIdSurveyInstancesHiddenVariablesApiArg = {
  surveyId: string;
  body: {
    ContentType?: string;
    ContentDisposition?: string;
    Headers?: {
      [key: string]: string[];
    };
    Length?: number;
    Name?: string;
    FileName?: string;
  };
};
export type PostAdminSurveyInstancesBulkCreateApiResponse =
  /** status 200 Success */ CreateSurveyInstanceResult[];
export type PostAdminSurveyInstancesBulkCreateApiArg = {
  bulkInstancesRequest: BulkInstancesRequest;
};
export type PostAdminSurveysSurveyInstancesBatchCreateAndSendApiResponse =
  /** status 200 Success */ SurveyInstancesResponse;
export type PostAdminSurveysSurveyInstancesBatchCreateAndSendApiArg = {
  batchCreateAndSendRequest: BatchCreateAndSendRequest;
};
export type PatchAdminSurveyInstancesBySurveyInstanceIdApiResponse =
  /** status 200 Success */ SurveyInstanceRead;
export type PatchAdminSurveyInstancesBySurveyInstanceIdApiArg = {
  surveyInstanceId: string;
  patchSurveyInstanceRequest: PatchSurveyInstanceRequest;
};
export type GetAdminSurveyInstancesBySurveyInstanceIdApiResponse =
  /** status 200 Success */ SurveyInstanceRead;
export type GetAdminSurveyInstancesBySurveyInstanceIdApiArg = {
  surveyInstanceId: string;
};
export type PatchAdminSurveyInstancesBySurveyInstanceIdDeadlineApiResponse =
  /** status 200 Success */ SurveyInstanceRead;
export type PatchAdminSurveyInstancesBySurveyInstanceIdDeadlineApiArg = {
  surveyInstanceId: string;
  updateSurveyInstanceDeadlineRequest: UpdateSurveyInstanceDeadlineRequest;
};
export type GetAdminSurveyInstancesApiResponse = /** status 200 Success */ SurveyInstanceRead[];
export type GetAdminSurveyInstancesApiArg = {
  boxId?: string;
  surveyType?: string;
};
export type PostAdminSurveyInstancesNotifyClientParticipantsOfSurveysApiResponse =
  /** status 200 Success */ SurveyInstanceRead[];
export type PostAdminSurveyInstancesNotifyClientParticipantsOfSurveysApiArg = {
  notifyClientParticipantsRequest: NotifyClientParticipantsRequest;
};
export type GetAdminSurveyInstancesCountsByProjectByProjectIdApiResponse =
  /** status 200 Success */ HighlighterSurveyInstanceCount[];
export type GetAdminSurveyInstancesCountsByProjectByProjectIdApiArg = {
  projectId: number;
};
export type PostAdminSurveysApiResponse = /** status 200 Success */ Survey;
export type PostAdminSurveysApiArg = {
  survey: Survey;
};
export type PutAdminSurveysApiResponse = /** status 200 Success */ Survey;
export type PutAdminSurveysApiArg = {
  survey: Survey;
};
export type GetAdminSurveysApiResponse = /** status 200 Success */ Survey[];
export type GetAdminSurveysApiArg = {
  projectId?: number;
};
export type PutAdminSurveysByIdApiResponse = /** status 200 Success */ Survey;
export type PutAdminSurveysByIdApiArg = {
  id: string;
  survey: Survey;
};
export type GetAdminSurveysByIdApiResponse = /** status 200 Success */ Survey;
export type GetAdminSurveysByIdApiArg = {
  /** The Id of the survey to retrieve. */
  id: string;
};
export type PostAdminSurveysBulkGetByIdsApiResponse = /** status 200 Success */ Survey[];
export type PostAdminSurveysBulkGetByIdsApiArg = {
  bulkGetSurveysRequest: BulkGetSurveysRequest;
};
export type PostAdminSurveysGetFromLinkUrlsApiResponse = /** status 200 Success */ string[];
export type PostAdminSurveysGetFromLinkUrlsApiArg = {
  /** The inks of the surveys to retrieve. */
  getSurveyByLinkUrlsRequest: GetSurveyByLinkUrlsRequest;
};
export type PostAdminSurveysGetSurveysFromLinkUrlsApiResponse = /** status 200 Success */ Survey[];
export type PostAdminSurveysGetSurveysFromLinkUrlsApiArg = {
  getSurveyByLinkUrlsRequest: GetSurveyByLinkUrlsRequest;
};
export type PutAdminSurveysBySurveyIdActionsApiResponse =
  /** status 200 Success */ SurveyInstanceRead[];
export type PutAdminSurveysBySurveyIdActionsApiArg = {
  surveyId: string;
  surveyActionRequest: SurveyActionRequest;
};
export type PostAdminSurveysByProfileSurveyIdSendprofilesurveyApiResponse =
  /** status 200 Success */ CreateSurveyInstanceResult;
export type PostAdminSurveysByProfileSurveyIdSendprofilesurveyApiArg = {
  profileSurveyId: string;
};
export type PostAdminSurveysBySurveyIdSenditemsurveyApiResponse =
  /** status 200 Success */ SurveyInstanceResultItemBatchOperationResultRead;
export type PostAdminSurveysBySurveyIdSenditemsurveyApiArg = {
  surveyId: string;
  highlighterIdsRequest: HighlighterIdsRequest;
};
export type PostAdminSurveysBySurveyIdNudgeApiResponse = /** status 200 Success */ string[];
export type PostAdminSurveysBySurveyIdNudgeApiArg = {
  surveyId: string;
  body: string[];
};
export type PostAdminSurveysBySurveyIdFailedQcApiResponse =
  /** status 200 Success */ SurveyInstanceRead[];
export type PostAdminSurveysBySurveyIdFailedQcApiArg = {
  surveyId: string;
  body: string[];
};
export type GetAdminSurveysBySurveyIdPreviewNudgeApiResponse =
  /** status 200 Success */ PreviewEmailTemplate;
export type GetAdminSurveysBySurveyIdPreviewNudgeApiArg = {
  surveyId: string;
};
export type GetAdminSurveysBySurveyIdSurveyInstanceStatusCountsApiResponse =
  /** status 200 Success */ {
    'not sent'?: number;
    sent?: number;
    completed?: number;
    expired?: number;
    cancelled?: number;
    started?: number;
    overdue?: number;
    disqualified?: number;
    declined?: number;
    'pending response'?: number;
    'failed qc'?: number;
  };
export type GetAdminSurveysBySurveyIdSurveyInstanceStatusCountsApiArg = {
  surveyId: string;
};
export type PostAuthTokenApiResponse = /** status 200 Success */ TokenResponseRead;
export type PostAuthTokenApiArg = {
  tokenRequest: TokenRequest;
};
export type BoxStatus =
  | 'created'
  | 'items-assigned'
  | 'submitted-for-fulfillment'
  | 'shipped'
  | 'item-surveys-sent'
  | 'item-surveys-completed'
  | 'opt-in-expired'
  | 'item-surveys-expired'
  | 'cancelled'
  | 'sent-extended'
  | 'expired-extended';
export type Client = {
  id?: string;
  name?: string | null;
  highlighterFacingName?: string | null;
  clientPortalId?: number | null;
  createdAt?: string;
  updatedAt?: string;
};
export type DeliveryStatus =
  | 'NotAssigned'
  | 'InfoReceived'
  | 'InTransit'
  | 'OutForDelivery'
  | 'AttemptFail'
  | 'Delivered'
  | 'AvailableForPickup'
  | 'Exception'
  | 'Expired'
  | 'Pending'
  | 'Received';
export type Box = {
  createdAt?: string;
  id?: string;
  highlighterId?: string;
  status?: BoxStatus;
  kitId?: number | null;
  project?: Client;
  deliveryStatus?: DeliveryStatus;
  trackingNumber?: string | null;
  deliveryCarrier?: string | null;
  expectedDelivery?: string | null;
  insertAssetId?: string | null;
  deliveredAt?: string | null;
};
export type BatchCreateByKitRequest = {
  highlighterIds?: string[] | null;
  kitId?: number;
  insertAssetId?: string | null;
};
export type DeliveryResultItem = {
  boxId?: string;
  success?: boolean;
  message?: string | null;
};
export type DeliveryResultItemBatchOperationResult = {
  success?: boolean;
  message?: string | null;
  items: DeliveryResultItem[];
};
export type DeliverBoxRequest = {
  boxIds: string[];
  deliveredAt?: string | null;
};
export type ChainOutcome = 'assigned' | 'notAssigned';
export type SurveyInstanceStatus =
  | 'not sent'
  | 'sent'
  | 'completed'
  | 'expired'
  | 'cancelled'
  | 'started'
  | 'overdue'
  | 'disqualified'
  | 'declined'
  | 'pending response'
  | 'failed qc';
export type SurveyInstanceType = 'optInSurvey' | 'itemSurvey' | 'oneOff' | 'profileSurvey';
export type HighlighterSurvey = {
  linkUrl?: string | null;
  id?: string | null;
  surveyId?: string;
  imageUrl?: string | null;
  isChained?: boolean;
  previousId?: string | null;
  clientId?: string | null;
  client?: Client;
  name?: string | null;
  questionCount?: number | null;
  status?: SurveyInstanceStatus;
  type?: SurveyInstanceType;
  customData?: {
    [key: string]: string;
  } | null;
  deadline?: string;
  availableAt?: string | null;
  addedManually?: boolean;
};
export type HighlighterSurveyRead = {
  linkUrl?: string | null;
  id?: string | null;
  surveyId?: string;
  imageUrl?: string | null;
  isChained?: boolean;
  previousId?: string | null;
  clientId?: string | null;
  client?: Client;
  name?: string | null;
  questionCount?: number | null;
  status?: SurveyInstanceStatus;
  type?: SurveyInstanceType;
  customData?: {
    [key: string]: string;
  } | null;
  deadline?: string;
  availableAt?: string | null;
  addedManually?: boolean;
  isOverdue?: boolean;
  isVisible?: boolean;
};
export type AssetWithUrls = {
  id?: string | null;
  name?: string | null;
  url?: string | null;
  downloadUrl?: string | null;
};
export type HighlighterTaskType = 'survey' | 'group' | 'custom';
export type HighlighterTaskStatus = 'todo' | 'completed';
export type HighlighterTask = {
  type?: HighlighterTaskType;
  status?: HighlighterTaskStatus;
  surveys?: HighlighterSurvey[] | null;
  duration?: number;
  startAt?: string;
  endAt?: string;
  message?: string | null;
  action?: string | null;
};
export type HighlighterTaskRead = {
  type?: HighlighterTaskType;
  status?: HighlighterTaskStatus;
  surveys?: HighlighterSurveyRead[] | null;
  duration?: number;
  startAt?: string;
  endAt?: string;
  message?: string | null;
  action?: string | null;
};
export type StudyMode = 'turboInOrder' | 'laxInOrder' | 'laxOutOfOrder';
export type HighlighterStudy = {
  id?: string;
  projectId?: number;
  name?: string | null;
  nextDeadline?: string;
  lastDeadline?: string;
  surveys?: HighlighterSurvey[] | null;
  instructions?: AssetWithUrls;
  completedSurveys?: HighlighterSurvey[] | null;
  tasks?: HighlighterTask[] | null;
  instructionsIntro?: string | null;
  logisticsType?: string[] | null;
  mode?: StudyMode;
};
export type HighlighterStudyRead = {
  id?: string;
  projectId?: number;
  name?: string | null;
  nextDeadline?: string;
  lastDeadline?: string;
  surveys?: HighlighterSurveyRead[] | null;
  instructions?: AssetWithUrls;
  completedSurveys?: HighlighterSurveyRead[] | null;
  tasks?: HighlighterTaskRead[] | null;
  instructionsIntro?: string | null;
  logisticsType?: string[] | null;
  mode?: StudyMode;
  isSurveysPopulated?: boolean;
  isCompleted?: boolean;
  upcoming?: boolean;
};
export type ChainResponse = {
  outcome?: ChainOutcome;
  study?: HighlighterStudy;
};
export type ChainResponseRead = {
  outcome?: ChainOutcome;
  study?: HighlighterStudyRead;
};
export type FunnelDropOff = {
  count?: number;
  percent?: number;
};
export type FunnelChoiceSummary = {
  value?: string | null;
  count?: number;
  percent?: number;
};
export type FunnelAnswerSummary = {
  answeredCount?: number;
  answeredPercent?: number;
  choices?: FunnelChoiceSummary[] | null;
};
export type FunnelQuestionRow = {
  index?: number;
  name?: string | null;
  title?: string | null;
  type?: string | null;
  isConditionallyShown?: boolean;
  viewCount?: number;
  dropOff?: FunnelDropOff;
  summary?: FunnelAnswerSummary;
};
export type FunnelSummaryResponse = {
  surveyId?: string;
  materializedSurveyId?: string | null;
  rows?: FunnelQuestionRow[] | null;
};
export type HighlighterAddress = {
  id?: string | null;
  country?: string | null;
  city?: string | null;
  lineThree?: string | null;
  lineTwo?: string | null;
  lineOne?: string | null;
  postalCode?: string | null;
  /** Region is a calcuated field set in the database.
    Its based on the Highlighter's State. */
  region?: string | null;
  state?: string | null;
  specialDeliveryInstructions?: string | null;
  createdAt?: string;
  updatedAt?: string | null;
};
export type HighlighterStatus =
  | 'active'
  | 'banned'
  | 'deleted'
  | 'disabled'
  | 'new'
  | 'stale'
  | 'quit'
  | 'guest';
export type PointTransactionType = 'add' | 'withdraw';
export type PointTransactionReason =
  | 'projectcomplete'
  | 'optin'
  | 'idi'
  | 'photo'
  | 'video'
  | 'other';
export type PointTransaction = {
  id?: string | null;
  highlighterId?: string;
  amount?: number;
  type?: PointTransactionType;
  reason?: PointTransactionReason;
  reasonDetail?: string | null;
  surveyId?: string | null;
  projectId?: number | null;
  createdAt?: string;
};
export type HighlighterPoints = {
  currentPoints?: number;
  lifetimePoints?: number;
  transactions?: PointTransaction[] | null;
};
export type Highlighter = {
  address?: HighlighterAddress;
  createdAt?: string;
  communitySlug?: string | null;
  dateOfBirth?: string | null;
  deletedAt?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  id?: string | null;
  phone?: string | null;
  phoneVerified?: boolean;
  signUpReferralCode?: string | null;
  status?: HighlighterStatus;
  updatedAt?: string | null;
  tosAgreedAt?: string | null;
  pointStats?: HighlighterPoints;
};
export type PatchHighlighterEmailRequest = {
  email?: string | null;
};
export type UpdateHighlighterDateOfBirthRequest = {
  dateOfBirth?: string;
};
export type ActivateHighlighterResponse = {
  highlighter?: Highlighter;
  /** HighlighterApi.Surveys.SurveyInstanceType.ProfileSurvey surveys that must be completed before a highlighter can be
                transitioned to Active status. For the Highlight community the only core profile surveys are Personal and
                Household profile surveys. */
  coreProfile?: HighlighterSurvey[] | null;
  additionalSurveys?: HighlighterSurvey[] | null;
  isStudyExpired?: boolean;
  applicationSurvey?: HighlighterSurvey;
};
export type ActivateHighlighterResponseRead = {
  highlighter?: Highlighter;
  /** HighlighterApi.Surveys.SurveyInstanceType.ProfileSurvey surveys that must be completed before a highlighter can be
                transitioned to Active status. For the Highlight community the only core profile surveys are Personal and
                Household profile surveys. */
  coreProfile?: HighlighterSurveyRead[] | null;
  additionalSurveys?: HighlighterSurveyRead[] | null;
  isStudyExpired?: boolean;
  applicationSurvey?: HighlighterSurveyRead;
};
export type ActivateAccountResponse = {
  activated?: boolean;
  highlighter?: Highlighter;
};
export type DetailsRequired = {
  needsPhoneVerification?: boolean;
  needsName?: boolean;
  needsDateOfBirth?: boolean;
  needsAddress?: boolean;
};
export type DetailsRequiredRead = {
  needsPhoneVerification?: boolean;
  needsName?: boolean;
  needsDateOfBirth?: boolean;
  needsAddress?: boolean;
  anyRequired?: boolean;
};
export type OnboardingStateResponse = {
  highlighter?: Highlighter;
  coreProfile?: HighlighterSurvey[] | null;
  additionalSurveys?: HighlighterSurvey[] | null;
  applicationSurvey?: HighlighterSurvey;
  detailsRequired?: DetailsRequired;
};
export type OnboardingStateResponseRead = {
  highlighter?: Highlighter;
  coreProfile?: HighlighterSurveyRead[] | null;
  additionalSurveys?: HighlighterSurveyRead[] | null;
  applicationSurvey?: HighlighterSurveyRead;
  detailsRequired?: DetailsRequiredRead;
};
export type ChangeSubscriptionSettingsRequest = {
  optInNudgesDisabled?: boolean;
};
export type HighlighterSubscriptionSettings = {
  optInNudgesDisabled?: boolean;
};
export type ProfileAnswers = {
  questionLabel?: string | null;
  answerTexts?: string[] | null;
};
export type ReceiveBoxRequest = {
  projectId?: number | null;
  deliveredAt?: string | null;
};
export type HighlighterExperienceStepKind =
  | 'Wait'
  | 'UseProduct'
  | 'TakeStandaloneSurvey'
  | 'TakeProductSurvey';
export type HighlighterExperienceStep = {
  id?: string;
  kind?: HighlighterExperienceStepKind;
  day?: number;
  ordinal?: number;
  durationDays?: number;
  productId?: number | null;
  surveyUuid?: string | null;
};
export type HighlighterExperienceStepStatus = 'done' | 'available' | 'availableOverdue' | 'blocked';
export type HighlighterExperienceStepMeta = {
  status?: HighlighterExperienceStepStatus;
  surveyInstanceId?: string | null;
};
export type HighlighterExperienceProgress = {
  highlighterId?: string;
  highlighterExperienceId?: string;
  currentDay?: number | null;
  stepMetaByStepId?: {
    [key: string]: HighlighterExperienceStepMeta;
  } | null;
};
export type HighlighterStudyV10 = {
  steps?: HighlighterExperienceStep[] | null;
  progress?: HighlighterExperienceProgress;
  productNameHighlighterFacingById?: {
    [key: string]: string;
  } | null;
  surveyNameHighlighterFacingByUuid?: {
    [key: string]: string;
  } | null;
};
export type StartGenerationResponse = {
  jobId?: string | null;
  referralCode?: string | null;
};
export type HighlighterGenerationJobStatus = {
  jobId?: string | null;
  status?: string | null;
  createdAt?: string;
  updatedAt?: string | null;
  generatedHighlighterIds?: string[] | null;
  errorMessage?: string | null;
  referralCode?: string | null;
  communitySlug?: string | null;
};
export type HighlighterNote = {
  createdAt?: string;
  id?: string;
  note?: string | null;
  updatedAt?: string | null;
};
export type BulkCreateNoteResponse = {
  notesCreated?: number;
};
export type BulkCreateNoteRequest = {
  highlighterIds?: string[] | null;
  note?: string | null;
};
export type PossibleAnswer = {
  id?: string;
  description?: string | null;
  slug?: string | null;
};
export type HighlighterQuestion = {
  id?: string;
  title?: string | null;
  description?: string | null;
  allowMultiple?: boolean;
  possibleAnswers?: PossibleAnswer[] | null;
};
export type BulkGetHighlightersRequest = {
  highlighterIds?: string[] | null;
  highlighterEmails?: string[] | null;
};
export type NotificationContactAddress = {
  lineOne?: string | null;
  lineTwo?: string | null;
  lineThree?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  country?: string | null;
};
export type NotificationHighlighterContact = {
  highlighterId?: string;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  address?: NotificationContactAddress;
  mailingAddress?: string | null;
  communitySlug?: string | null;
};
export type BulkResolveNotificationContactsRequest = {
  highlighterIds?: string[] | null;
};
export type PatchHighlighterRequest = {
  dateOfBirth?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phone?: string | null;
  phoneVerified?: boolean | null;
  status?: HighlighterStatus;
  signUpReferralCode?: string | null;
};
export type PatchBulkHighlighterStatusRequest = {
  newStatus: HighlighterStatus;
  highlighterIds?: string[] | null;
};
export type ManageApplicationStatusRequest = {
  applicationApproved?: boolean;
  highlighterId?: string;
};
export type PatchHighlighterDateOfBirthRequest = {
  dateOfBirth?: string;
};
export type EmailTemplateData = {
  highlighterIds?: string[] | null;
};
export type SendAcceptedIntoStudyEmailsRequest = {
  projectId?: number;
  projectName?: string | null;
  emailTemplateData?: EmailTemplateData[] | null;
};
export type HighlighterBulkCreateOutcome = 'Create' | 'Ignore' | 'Reject';
export type HighlighterBulkCreateResultItem = {
  outcome?: HighlighterBulkCreateOutcome;
  message?: string | null;
};
export type HighlighterBulkCreateResultItemRead = {
  outcome?: HighlighterBulkCreateOutcome;
  success?: boolean;
  message?: string | null;
};
export type HighlighterBulkCreateResultItemBatchOperationResult = {
  success?: boolean;
  message?: string | null;
  items: HighlighterBulkCreateResultItem[];
};
export type HighlighterBulkCreateResultItemBatchOperationResultRead = {
  success?: boolean;
  message?: string | null;
  items: HighlighterBulkCreateResultItemRead[];
};
export type ProfileSurvey = {
  highlighterSurvey?: HighlighterSurvey;
  isCore?: boolean;
};
export type ProfileSurveyRead = {
  highlighterSurvey?: HighlighterSurveyRead;
  isCore?: boolean;
};
export type PatchHighlighterSurveyRequest = {
  status: SurveyInstanceStatus;
};
export type DeclineRequest = {
  surveyId?: string;
  highlighterId?: string;
};
export type HighlighterSurveyAdmin = {
  project?: Client;
  /** Let UI know if this is legacy or not.
    Legacy means the Survey comes from: dispatched_item_surveys */
  isLegacy?: boolean;
  linkUrl?: string | null;
  id?: string | null;
  surveyId?: string;
  imageUrl?: string | null;
  isChained?: boolean;
  previousId?: string | null;
  clientId?: string | null;
  client?: Client;
  name?: string | null;
  questionCount?: number | null;
  status?: SurveyInstanceStatus;
  type?: SurveyInstanceType;
  customData?: {
    [key: string]: string;
  } | null;
  deadline?: string;
  availableAt?: string | null;
  addedManually?: boolean;
};
export type HighlighterSurveyAdminRead = {
  project?: Client;
  /** Let UI know if this is legacy or not.
    Legacy means the Survey comes from: dispatched_item_surveys */
  isLegacy?: boolean;
  linkUrl?: string | null;
  id?: string | null;
  surveyId?: string;
  imageUrl?: string | null;
  isChained?: boolean;
  previousId?: string | null;
  clientId?: string | null;
  client?: Client;
  name?: string | null;
  questionCount?: number | null;
  status?: SurveyInstanceStatus;
  type?: SurveyInstanceType;
  customData?: {
    [key: string]: string;
  } | null;
  deadline?: string;
  availableAt?: string | null;
  addedManually?: boolean;
  isOverdue?: boolean;
  isVisible?: boolean;
};
export type HighlighterTag = {
  /** This is the date the highlighter was assigned this tag.
    This is NOT the date the tag was created */
  createdAt?: string;
  description?: string | null;
  id?: string;
  title?: string | null;
};
export type BulkAssociateTagResponse = {
  highlightersEffected?: number;
};
export type BulkAssociateTagRequest = {
  highlighterIds: string[];
};
export type MaterializedSurveyGroupData = {
  ids?: string[] | null;
  shouldShuffle?: boolean;
};
export type MaterializedSurveyMetadata = {
  groupData?: MaterializedSurveyGroupData[] | null;
};
export type MaterializedSurveyDto = {
  id?: string | null;
  vendorName?: string | null;
  json?: string | null;
  metadata?: MaterializedSurveyMetadata;
  isLatched?: boolean;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
};
export type ZeroSurveyResponse = {
  answers?: string[] | null;
};
export type SjsPlainData = {
  name?: string | null;
  title?: string | null;
  value?: any | null;
  displayValue?: any | null;
  otherText?: string | null;
  isNode?: boolean;
};
export type SjsVariable = {
  name?: string | null;
  value?: any | null;
};
export type SjsSurveyResponse = {
  eventId?: string | null;
  highlighterId?: string | null;
  surveyId?: string | null;
  surveyInstanceId?: string | null;
  timeSpentSeconds?: number;
  plainData?: SjsPlainData[] | null;
  variables?: SjsVariable[] | null;
};
export type VendorSurveyResponse = {
  vendorName?: string | null;
  vendorSurveyId?: string | null;
  vendorResponseId?: string | null;
  responseZero?: ZeroSurveyResponse;
  responseSjs?: SjsSurveyResponse;
};
export type SequenceSurvey = {
  name?: string | null;
  linkUrl?: string | null;
};
export type Sequence = {
  name?: string | null;
  surveys?: SequenceSurvey[] | null;
};
export type CreateGuestHighlighterRequest = {
  onboardingCode?: string | null;
  communitySlug?: string | null;
  type?: string | null;
  sequences?: Sequence[] | null;
};
export type TurnOffParticipantGuidanceRequest = {
  projectId?: number;
  newSurveyDeadline?: string | null;
};
export type HighlighterRewardsEstimate = {
  eligibleHighlighterCount?: number;
  pointsToWithdraw?: number;
  estimatedPayoutDollars?: number;
};
export type HlSurveyType = 'optInSurvey' | 'oneOff' | 'itemSurvey' | 'profileSurvey';
export type Survey = {
  deadline?: string;
  /** DurationDays should only be set for item surveys. */
  durationDays?: number | null;
  /** Link to the 3rd party survey. */
  linkUrl?: string | null;
  id?: string | null;
  imageUrl?: string | null;
  isChained?: boolean;
  questionCount?: number | null;
  name?: string | null;
  createdAt?: string;
  updatedAt?: string;
  type?: HlSurveyType;
  instanceAddedBrevoTemplateId?: number | null;
  reminderBrevoTemplateId?: number | null;
  /** Custom email text for reminder emails. */
  customEmailText?: string | null;
  /** Custom email text for initial emails (survey instance added). */
  customInitialEmailText?: string | null;
  clientId?: string | null;
  projectId?: number | null;
  internalName?: string | null;
  client?: Client;
  nudges?: string[] | null;
};
export type CompositeSlot = {
  slotValueId?: string | null;
  slotId?: string;
  key?: string | null;
  value?: string | null;
  slotType?: string | null;
  assetId?: string | null;
  externalUrl?: string | null;
  label?: string | null;
  placeholder?: string | null;
  slotValueOptions?: string[] | null;
  canApplyAllWithinSurveys?: boolean;
  isRequired?: boolean;
};
export type QuestionCompositeSlotAsset = {
  asset?: AssetWithUrls;
  compositeSlot?: CompositeSlot;
};
export type QuestionDesignChoice = {
  id?: string | null;
  questionDesignId?: string;
  label?: string | null;
  ordinal?: number;
  type?: string | null;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
};
export type SurveyConfigQuestionChoice = {
  id?: string;
  surveyConfigQuestionId?: string;
  questionDesignChoice?: QuestionDesignChoice;
  assetId?: string | null;
  externalUrl?: string | null;
  altText?: string | null;
};
export type QuestionChoiceAsset = {
  asset?: AssetWithUrls;
  questionChoice?: SurveyConfigQuestionChoice;
};
export type QuestionAsset = {
  surveyConfigQuestionId?: string;
  compositeSlotAssets?: QuestionCompositeSlotAsset[] | null;
  questionChoiceAssets?: QuestionChoiceAsset[] | null;
};
export type RawSurveyData = {
  id?: string;
  surveyInstanceId?: string;
  /** Raw JSON string containing the state for this survey instance. */
  data?: string | null;
  createdAt?: string;
  updatedAt?: string;
};
export type RawSurveyDataRequest = {
  /** Arbitrary SurveyJS state object to persist for this survey instance. */
  data?: any | null;
};
export type ReferralCode = {
  id?: string;
  code?: string | null;
  active?: boolean;
  expiration?: string | null;
  timesUsed?: number;
  maxTimesUsed?: number | null;
  customerId?: string | null;
  notes?: string | null;
  createdAt?: string;
  updatedAt?: string | null;
  oneTimeUse?: boolean;
  requiredSurveyIds?: string[] | null;
  isExternal?: boolean;
  isRecruitable?: boolean;
};
export type BatchCreateReferralCodesResult = {
  created?: number;
  failed?: number;
  totalProcessed?: number;
  errors?: string[] | null;
};
export type SurveyInstanceResponseStatus = 'success' | 'failed';
export type SurveyInstanceResponse = {
  customerId?: string;
  status?: SurveyInstanceResponseStatus;
  detail?: string | null;
};
export type CreateSurveyInstanceResult = {
  emailsSent?: boolean;
  surveyInstances?: SurveyInstanceResponse[] | null;
};
export type ItemSurveyBox = {
  expectedDelivery?: string | null;
  deliveryStatus?: string | null;
};
export type EmailHistoryEntry = {
  id?: string | null;
  customerId?: string | null;
  surveyId?: string | null;
  createdAt?: string | null;
  templateUsed?: string | null;
};
export type SurveyInstance = {
  /** Deprecated field. Previously used to track chained survey */
  previousInstanceId?: string | null;
  email?: string | null;
  type?: SurveyInstanceType;
  updatedAt?: string;
  box?: ItemSurveyBox;
  customData?: {
    [key: string]: string;
  } | null;
  addedManually?: boolean;
  name?: string | null;
  client?: Client;
  clientId?: string | null;
  highlighterExperienceAssignmentId?: string | null;
  emailHistory?: EmailHistoryEntry[] | null;
  id?: string;
  customerId?: string;
  surveyId?: string;
  status?: SurveyInstanceStatus;
  createdAt?: string;
  deadline?: string | null;
  availableAt?: string | null;
  lastNudge?: string | null;
};
export type SurveyInstanceRead = {
  /** Deprecated field. Previously used to track chained survey */
  previousInstanceId?: string | null;
  email?: string | null;
  type?: SurveyInstanceType;
  updatedAt?: string;
  box?: ItemSurveyBox;
  customData?: {
    [key: string]: string;
  } | null;
  addedManually?: boolean;
  name?: string | null;
  client?: Client;
  clientId?: string | null;
  highlighterExperienceAssignmentId?: string | null;
  emailHistory?: EmailHistoryEntry[] | null;
  /** IsVisibleToHighlighter depends on nullable fields and is set to false when visibility is unknown. */
  isVisibleToHighlighter?: boolean;
  isStatusTerminal?: boolean;
  isFinalized?: boolean;
  id?: string;
  customerId?: string;
  surveyId?: string;
  status?: SurveyInstanceStatus;
  createdAt?: string;
  deadline?: string | null;
  availableAt?: string | null;
  lastNudge?: string | null;
};
export type StringStringKeyValuePair = {
  key?: string | null;
  value?: string | null;
};
export type CreateInstancesRequest = {
  highlighterIds?: string[] | null;
  surveyIds?: string[] | null;
  customData?: StringStringKeyValuePair[] | null;
};
export type BulkInstancesRequest = {
  createInstancesRequests?: CreateInstancesRequest[] | null;
  setAvailableAt?: boolean;
};
export type SurveyInstancesResponse = {
  CustomerId?: string;
  status?: string[] | null;
  detail?: string | null;
};
export type BatchCreateAndSendRequest = {
  customData?: {
    [key: string]: string;
  } | null;
  highlighterId?: string;
  surveyIds?: string[] | null;
};
export type PatchSurveyInstanceRequest = {
  status: SurveyInstanceStatus;
  reviewStatus?: string | null;
};
export type UpdateSurveyInstanceDeadlineRequest = {
  deadline: string;
};
export type NotifyClientParticipantsRequest = {
  projectIds?: number[] | null;
};
export type HighlighterSurveyInstanceCount = {
  highlighterId?: string;
  instanceCount?: number;
};
export type BulkGetSurveysRequest = {
  surveyIds?: string[] | null;
};
export type GetSurveyByLinkUrlsRequest = {
  linkUrls?: string[] | null;
};
export type SurveyAction = 'Cancel' | 'Expire' | 'Nudge' | 'Refresh';
export type SurveyActionRequest = {
  action: SurveyAction;
  customerIds?: string[] | null;
};
export type SurveyInstanceOutcome = 'Create' | 'Reset' | 'Ignore' | 'Reject';
export type SurveyInstanceResultItem = {
  outcome?: SurveyInstanceOutcome;
  highlighterId?: string;
  message?: string | null;
  patch?: SurveyInstance;
};
export type SurveyInstanceResultItemRead = {
  outcome?: SurveyInstanceOutcome;
  highlighterId?: string;
  message?: string | null;
  patch?: SurveyInstanceRead;
  success?: boolean;
};
export type SurveyInstanceResultItemBatchOperationResult = {
  success?: boolean;
  message?: string | null;
  items: SurveyInstanceResultItem[];
};
export type SurveyInstanceResultItemBatchOperationResultRead = {
  success?: boolean;
  message?: string | null;
  items: SurveyInstanceResultItemRead[];
};
export type HighlighterIdsRequest = {
  highlighterIds?: string[] | null;
};
export type PreviewEmailTemplate = {
  nudgeHtml?: string | null;
  instanceAddedHtml?: string | null;
};
export type TokenResponse = {
  access_token?: string | null;
  expires_in?: number;
};
export type TokenResponseRead = {
  access_token?: string | null;
  token_type?: string | null;
  expires_in?: number;
};
export type TokenRequest = {
  grant_type?: string | null;
  assertion?: string | null;
};
export const {
  usePostAdminProjectsByProjectIdBoxesBatchCreateByKitMutation,
  useGetAdminProjectsByProjectIdBoxesQuery,
  useDeleteAdminBoxesByBoxIdMutation,
  useGetAdminBoxesByBoxIdQuery,
  usePostAdminBoxesDeliverMutation,
  useGetMyChainingBySurveyInstanceIdQuery,
  useGetAdminClientsQuery,
  usePostMyMaterializedSurveysFilesMutation,
  usePostAdminMaterializedSurveysFilesMutation,
  useGetAdminSurveysBySurveyIdFunnelSummaryQuery,
  useGetMyHighlighterAccountsQuery,
  usePostMyHighlighterAccountsMutation,
  usePutMyHighlighterAccountsMutation,
  useDeleteMyHighlighterAccountsMutation,
  usePatchMyHighlighterAccountsEmailMutation,
  usePutMyHighlighterAccountsDeactivateMutation,
  usePostMyHighlighterAccountsBirthdateMutation,
  usePostMyHighlighterAccountsActivateHighlighterMutation,
  usePostMyHighlighterAccountsActivateAccountMutation,
  usePostMyHighlighterAccountsAcceptTosMutation,
  useGetMyHighlighterAccountsGetOnboardingStateQuery,
  usePostHighlighterAccountsSubscriptionSettingsByHighlighterIdMutation,
  useGetHighlighterAccountsSubscriptionSettingsByHighlighterIdQuery,
  usePutMyHighlighterAddressesMutation,
  usePostMyHighlighterAddressesMutation,
  usePutAdminHighlightersByHighlighterIdAddressMutation,
  usePostAdminHighlightersByHighlighterIdAddressMutation,
  useGetMyHighlighterAnswersSurveysBySurveyInstanceIdAnswersQuery,
  usePostMyBoxesReceiveMutation,
  useGetMyHighlighterExperiencesQuery,
  usePostAdminHighlighterGenerationGenerateMutation,
  useGetAdminHighlighterGenerationJobsQuery,
  useGetAdminHighlightersByHighlighterIdNotesQuery,
  usePostAdminHighlightersByHighlighterIdNotesMutation,
  usePostAdminNotesMutation,
  useDeleteAdminNotesByNoteIdMutation,
  useGetAdminHighlighterQuestionsQuery,
  useGetAdminHighlightersByIdQuery,
  useGetAdminHighlightersQuery,
  useDeleteAdminHighlightersMutation,
  usePostAdminHighlightersBulkGetMutation,
  usePostAdminHighlightersBulkGetHighlightersMutation,
  usePostAdminHighlightersBulkResolveNotificationContactsMutation,
  useGetAdminHighlightersByHighlighterIdGetOnboardingStateQuery,
  useGetAdminHighlightersByHighlighterIdBoxesQuery,
  usePatchAdminHighlightersByHighlighterIdMutation,
  usePatchAdminHighlightersStatusMutation,
  usePatchAdminHighlightersApplicationStatusMutation,
  usePatchAdminHighlightersByHighlighterIdDateofbirthMutation,
  usePatchAdminHighlightersByHighlighterIdEmailMutation,
  usePostAdminHighlightersSendAcceptedIntoStudyEmailsMutation,
  usePostAdminHighlightersImportMutation,
  useGetAdminHighlightersGetByReferralCodeByReferralCodeQuery,
  useGetMyStudiesQuery,
  useGetMyProfileSurveysQuery,
  usePatchMyHighlighterSurveysBySurveyInstanceIdMutation,
  usePostHighlighterSurveysDeclineMutation,
  useGetAdminHighlightersByHighlighterIdSurveysQuery,
  useGetAdminTagsQuery,
  useGetAdminHighlightersByHighlighterIdTagsQuery,
  useDeleteAdminHighlightersByHighlighterIdTagsAndTagIdMutation,
  usePatchAdminTagsByTagIdMutation,
  useGetMyMaterializedSurveysBySurveyInstanceIdQuery,
  usePostMyMaterializedSurveysResponsesMutation,
  usePostMyHighlighterAccountsGuestMutation,
  usePutAdminParticipantGuidanceMutation,
  usePostAdminPointTransactionBulkMutation,
  useGetAdminHighlightersByHighlighterIdPointTransactionQuery,
  usePostAdminPointTransactionGetRewardsCsvMutation,
  useGetAdminPointTransactionGetRewardsEstimateQuery,
  useGetAdminPointTransactionQuery,
  useGetAdminProjectsByIdSurveysQuery,
  useGetMyHighlighterSurveysBySurveyInstanceIdQuestionAssetsQuery,
  usePutMyRawSurveyDataBySurveyInstanceIdMutation,
  useGetAdminReferralCodesQuery,
  usePostAdminReferralCodesMutation,
  useGetAdminReferralCodesByIdQuery,
  usePutAdminReferralCodesByReferralCodeIdMutation,
  usePostAdminReferralCodesBatchCreateMutation,
  useGetAdminStudiesByHighlighterIdQuery,
  usePostAdminSurveysBySurveyIdSurveyInstancesMutation,
  useGetAdminSurveysBySurveyIdSurveyInstancesQuery,
  usePutAdminSurveysBySurveyIdSurveyInstancesHiddenVariablesMutation,
  usePostAdminSurveyInstancesBulkCreateMutation,
  usePostAdminSurveysSurveyInstancesBatchCreateAndSendMutation,
  usePatchAdminSurveyInstancesBySurveyInstanceIdMutation,
  useGetAdminSurveyInstancesBySurveyInstanceIdQuery,
  usePatchAdminSurveyInstancesBySurveyInstanceIdDeadlineMutation,
  useGetAdminSurveyInstancesQuery,
  usePostAdminSurveyInstancesNotifyClientParticipantsOfSurveysMutation,
  useGetAdminSurveyInstancesCountsByProjectByProjectIdQuery,
  usePostAdminSurveysMutation,
  usePutAdminSurveysMutation,
  useGetAdminSurveysQuery,
  usePutAdminSurveysByIdMutation,
  useGetAdminSurveysByIdQuery,
  usePostAdminSurveysBulkGetByIdsMutation,
  usePostAdminSurveysGetFromLinkUrlsMutation,
  usePostAdminSurveysGetSurveysFromLinkUrlsMutation,
  usePutAdminSurveysBySurveyIdActionsMutation,
  usePostAdminSurveysByProfileSurveyIdSendprofilesurveyMutation,
  usePostAdminSurveysBySurveyIdSenditemsurveyMutation,
  usePostAdminSurveysBySurveyIdNudgeMutation,
  usePostAdminSurveysBySurveyIdFailedQcMutation,
  useGetAdminSurveysBySurveyIdPreviewNudgeQuery,
  useGetAdminSurveysBySurveyIdSurveyInstanceStatusCountsQuery,
  usePostAuthTokenMutation,
} = injectedRtkApi;
